import { FC } from "react";
import { Text } from "@postenbring/hedwig-react";
import { faBuilding } from "@fortawesome/pro-solid-svg-icons/faBuilding";
import styles from "./OrganizationList.module.css";
import Translated from "../infrastructure/translation/Translated";
import { useRootPath } from "../infrastructure/translation/useRootPath";
import { useTranslate } from "../infrastructure/translation/useTranslate";
import { useOrganizations } from "../infrastructure/organization/OrganizationContext";
import { ListRow, ListRows } from "../ListRow/ListRow";

export const OrganizationList: FC = () => {
  const rootPath = useRootPath();
  const translate = useTranslate();
  const allOrganizations = useOrganizations();

  if (allOrganizations.length === 0) {
    return (
      <main>
        <Text variant="h1" as="h1" size="min">
          <Translated textKey={"organizations.header"} />
        </Text>
        <p>
          <Translated textKey={"organizations.no_access"} />
        </p>
      </main>
    );
  }

  return (
    <main>
      <Text variant="h1" as="h1" size="min">
        <Translated textKey={"organizations.header"} />
      </Text>
      <Text variant="body-small" className={styles.description}>
        <Translated textKey={"organizations.description"} />
      </Text>
      <ListRows>
        {allOrganizations.map((orgRep) => (
          <ListRow
            key={orgRep.organization.orgnr}
            to={`${rootPath}/organization/${orgRep.organization.orgnr}`}
            icon={faBuilding}
            title={orgRep.organization.name}
            meta={`${translate("organizations.orgnr")} ${orgRep.organization.orgnr}`}
          />
        ))}
      </ListRows>
    </main>
  );
};
